export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M19 6v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-2-3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z\"/>"
};